import React, { useEffect } from 'react';
import { useStytchMemberSession } from '@stytch/react/b2b';
import Login from './Login';

const Authenticate = () => {
    const { session } = useStytchMemberSession();

    useEffect(() => {
        if (session) {
            window.location.href = '/';
        }
    }, [session]);

    return <Login />;
};

export default Authenticate;
